import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;
export const mediaUrl = (url) => `${API_ORIGIN}${url}`;

export const fmtDate = (iso, time = false) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric", ...(time ? { hour: "2-digit", minute: "2-digit" } : {}) });
};
export const fmtEur = (n) => (n == null ? "—" : new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(n));
export const fmtSize = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
export const fmtTime = (s) => (!s ? "0 min" : s < 3600 ? `${Math.round(s / 60)} min` : `${Math.floor(s / 3600)} h ${Math.round((s % 3600) / 60)} min`);
export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "No se pudo completar la acción. Inténtalo de nuevo.";
};

export function useFetch(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const reload = useCallback(() => {
    setError(false);
    return api.get(path).then((r) => setData(r.data)).catch(() => setError(true));
  }, [path]);
  useEffect(() => { reload(); }, [reload]);
  return { data, setData, error, reload };
}

export const PAY_STATUS = {
  activo: ["Activo", "ok"], cancela: ["Cancela al final", "warn"], vencido: ["Vencido", "bad"], gratuito: ["Gratuito", "mute"],
};
export const PAYMENT = { paid: ["Pagado", "ok"], failed: ["Fallido", "bad"], pending: ["Pendiente", "warn"] };
export const KIND = { video: "Vídeo", audio: "Audio", pdf: "PDF", image: "Imagen" };

export const Badge = ({ map, value, testid }) => {
  const [label, tone] = map[value] || [value, "mute"];
  return <span className={`adm-badge ${tone}`} data-testid={testid}>{label}</span>;
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="adm-head">
    <div><h1 data-testid="admin-page-title">{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
    {children && <div className="adm-row">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, hint, icon: Icon, testid }) => (
  <div className="adm-card adm-stat" data-testid={testid}>
    <div className="lbl"><span>{label}</span>{Icon && <Icon size={16} />}</div>
    <div className="val" data-testid={`${testid}-value`}>{value}</div>
    {hint && <div className="hint">{hint}</div>}
  </div>
);

export const Panel = ({ title, action, children, testid }) => (
  <section className="adm-card" data-testid={testid}>
    {(title || action) && <div className="adm-panel-h"><h2>{title}</h2>{action}</div>}
    {children}
  </section>
);

export const Empty = ({ text = "No se encontraron registros para los criterios seleccionados.", testid = "admin-empty" }) => (
  <div className="adm-empty" data-testid={testid}>{text}</div>
);

export const Loading = () => <div className="adm-empty" data-testid="admin-loading">Cargando...</div>;
export const ErrorBox = () => <div className="adm-empty" style={{ color: "#B91C1C" }} data-testid="admin-error">No se pudo cargar la información. Inténtalo de nuevo.</div>;

export const Progress = ({ value }) => (
  <div className="adm-row" style={{ gap: ".5rem", flexWrap: "nowrap" }}>
    <div className="adm-bar" style={{ flex: 1 }}><b style={{ width: `${value}%` }} /></div>
    <span className="adm-sub" style={{ minWidth: 32 }}>{value}%</span>
  </div>
);
